import type {
  QaEngagementParam,
  QaEngagementState,
  QaFeedListQuery,
  QaFeedListResult,
  QaFeedQuestion,
  QaSubmitQuestionPayload,
} from "./QaFeedType";

function pad2(n: number) {
  return String(n).padStart(2, "0");
}

function formatTs(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}

const IMG = (seed: string, w: number, h: number) =>
  `https://picsum.photos/seed/${encodeURIComponent(seed)}/${w}/${h}`;

let mockDb: QaFeedQuestion[] = [
  {
    id: "Qmock001",
    askerNickname: "晨曦",
    askerAvatar: IMG("qa-m1", 96, 96),
    askerDisplayId: "ABCDEFGHIJKL",
    askedAt: formatTs(new Date(Date.now() - 3600_000 * 6)),
    text: "老师好，想请教一下当前仓位偏成长，如果利率短期反弹该怎么调整？",
    images: [IMG("qa-q1", 520, 360)],
    answers: [
      {
        answerText: "建议先控制总杠杆，成长方向保留核心仓位，等待利率预期稳定后再做结构优化。",
        answeredAt: formatTs(new Date(Date.now() - 3600_000 * 4)),
        answererNickname: "研选王老师",
        answererAvatar: IMG("qa-t1", 96, 96),
      },
    ],
    isPublic: true,
    likeCount: 18,
    collectCount: 6,
    likedByMe: false,
    collectedByMe: false,
    isMine: false,
  },
];

async function listFeed(query: QaFeedListQuery): Promise<QaFeedListResult> {
  await new Promise((r) => setTimeout(r, 120));
  let list = [...mockDb];
  if (query.tab === "public") {
    list = list.filter((x) => x.isPublic);
  } else {
    list = list.filter((x) => x.isMine);
  }
  list.sort((a, b) => a.askedAt.localeCompare(b.askedAt));
  const start = (query.pageNum - 1) * query.pageSize;
  const slice = list.slice(start, start + query.pageSize);
  return { list: slice, total: list.length };
}

async function submitQuestion(payload: QaSubmitQuestionPayload): Promise<QaFeedQuestion> {
  await new Promise((r) => setTimeout(r, 120));
  const row: QaFeedQuestion = {
    id: `Qmock${Date.now()}`,
    askerNickname: "我",
    askerAvatar: "",
    askerDisplayId: "MOCKUSER0001",
    askedAt: formatTs(new Date()),
    text: payload.text.trim(),
    images: payload.imageUrls.slice(0, 9),
    answers: [],
    isPublic: false,
    likeCount: 0,
    collectCount: 0,
    likedByMe: false,
    collectedByMe: false,
    isMine: true,
  };
  mockDb = [...mockDb, row];
  return row;
}

async function toggleLike(param: QaEngagementParam): Promise<QaEngagementState> {
  const row = mockDb.find((x) => x.id === param.questionId);
  if (!row) {
    return { liked: false, collected: false, likeCount: 0, collectCount: 0 };
  }
  const liked = !row.likedByMe;
  row.likedByMe = liked;
  row.likeCount = Math.max(0, (row.likeCount ?? 0) + (liked ? 1 : -1));
  return {
    liked,
    collected: Boolean(row.collectedByMe),
    likeCount: row.likeCount ?? 0,
    collectCount: row.collectCount ?? 0,
  };
}

async function toggleCollect(param: QaEngagementParam): Promise<QaEngagementState> {
  const row = mockDb.find((x) => x.id === param.questionId);
  if (!row) {
    return { liked: false, collected: false, likeCount: 0, collectCount: 0 };
  }
  const collected = !row.collectedByMe;
  row.collectedByMe = collected;
  row.collectCount = Math.max(0, (row.collectCount ?? 0) + (collected ? 1 : -1));
  return {
    liked: Boolean(row.likedByMe),
    collected,
    likeCount: row.likeCount ?? 0,
    collectCount: row.collectCount ?? 0,
  };
}

export const qaFeedMocks = {
  listFeed,
  submitQuestion,
  toggleLike,
  toggleCollect,
};
